import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-night-icon',
  templateUrl: './night-icon.component.html',
  styleUrls: ['./night-icon.component.scss']
})
export class NightIconComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
